import {observer} from "mobx-react-lite";
import {Typography} from "@shared/ui/Typography/Typography";
import {Button} from "@shared/ui/Button";
import {socket} from "@services/socket/socketInstanse";
import {socketStore} from "@services/socket";
import {Loading} from "@shared/ui/Loading/Loading";
import styles from "./WaitingSocketConnection.module.scss";
import {Modal} from "@shared/ui/Modal/Modal";


export const WaitingSocketConnection = observer(() => {

    const {error, isLoading} = socketStore

    return (
        <>
            {/*<Modal isOpen={isLoading}>*/}
            {/*    <Loading/>*/}
            {/*</Modal>*/}
            <Modal isOpen={!!error}>
                <div className={styles.connectionError}>
                    <Typography adaptiveFontSize={1}>
                        Соединение прервано
                    </Typography>
                    <Button
                        color={"success"}
                        onClick={() => socket.connect()}
                    >
                        подключиться
                    </Button>
                </div>
            </Modal>
        </>
    )
})